import { getToken } from './user-service';

const FLIGHT_AUDIT_URL = '/api/v1/cpu/sla-reports/flightAuditReport';
const FLIGHTS_BY_DATETIME_URL = '/api/v1/flights/flight-search/flightsByDateTime';

/**
 * Fetch flights within a date/time range for dropdown display.
 *
 * @param {Object} params
 * @param {string} params.iata - Airport IATA code
 * @param {string} params.startDateTime - ISO format (YYYY-MM-DDTHH:mm)
 * @param {string} params.endDateTime - ISO format
 * @param {string} [params.type] - 'inbound' | 'outbound' | 'all' (default 'all')
 * @returns {Promise<{ flights: Array }>}
 */
export const getFlightsByDateTime = async (params) => {
  const token = await getToken();
  const { iata, startDateTime, endDateTime, type } = params;
  const queryParams = new URLSearchParams({
    iata,
    startDateTime,
    endDateTime,
  });
  if (type && type !== 'all') {
    queryParams.append('type', type);
  }
  const response = await fetch(`${FLIGHTS_BY_DATETIME_URL}?${queryParams.toString()}`, {
    headers: {
      'Content-Type': 'application/json',
      'Firebase-UID': token,
    },
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || err.errors?.[0]?.msg || `Flights by date range failed: ${response.status}`);
  }
  return response.json();
};

/**
 * Fetch flight audit report (geolocations + beacon events) from the backend.
 *
 * @param {Object} params
 * @param {string} params.iata - Airport IATA code
 * @param {string} params.employeeId - Employee ID
 * @param {string} params.startDate - Start datetime (ISO string)
 * @param {string} params.endDate - End datetime (ISO string)
 * @returns {Promise<{ geolocations: Array, beaconEvents: Array }>}
 */
export const getFlightAuditReport = async (params) => {
  const token = await getToken();
  const { iata, employeeId, startDate, endDate } = params;
  const queryParams = new URLSearchParams({
    iata,
    employeeId,
    startDate,
    endDate,
  });
  const response = await fetch(`${FLIGHT_AUDIT_URL}?${queryParams.toString()}`, {
    headers: {
      'Content-Type': 'application/json',
      'Firebase-UID': token,
    },
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.message || `Flight audit report failed: ${response.status}`);
  }
  return response.json();
};
